import { Button } from '../ui/button';
import { formatPoint, POINT_NAME } from '../../constants/point';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  balance: number;
}

const ExchangeBottomSheet = ({ isOpen, onClose, balance }: Props) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-2xl p-6 w-80 shadow-xl">
        <h3 className="text-lg font-bold text-gray-900 mb-1">{POINT_NAME} 꺼내기</h3>
        <p className="text-sm text-gray-500 mb-4">
          모은 {POINT_NAME}을 토스포인트로 바꿀 수 있어요
        </p>

        <div className="text-center py-4">
          <span className="text-2xl font-bold text-blue-600">
            {formatPoint(balance)}
          </span>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-4">
          <p className="text-sm text-amber-800 leading-relaxed">
            웹에서는 {POINT_NAME} 획득만 가능해요.
            조각을 토스 포인트로 바꾸려면 토스 앱에서 통합회원 전환 후 이용해 주세요.
          </p>
        </div>

        <Button className="w-full" variant="outline" onClick={onClose}>
          닫기
        </Button>
      </div>
    </div>
  );
};

export default ExchangeBottomSheet;
